export function pattern_diamond({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">

  <path fill="#444444" d="M54,174L0,228l-54-54l54-54L54,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M174,174l-54,54l-54-54l54-54L174,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M294,174l-54,54l-54-54l54-54L294,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M414,174l-54,54l-54-54l54-54L414,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M534,174l-54,54l-54-54l54-54L534,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M654,174l-54,54l-54-54l54-54L654,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M774,174l-54,54l-54-54l54-54L774,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M894,174l-54,54l-54-54l54-54L894,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1014,174l-54,54l-54-54l54-54L1014,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1134,174l-54,54l-54-54l54-54L1134,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1254,174l-54,54l-54-54l54-54L1254,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1374,174l-54,54l-54-54l54-54L1374,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1494,174l-54,54l-54-54l54-54L1494,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1614,174l-54,54l-54-54l54-54L1614,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1734,174l-54,54l-54-54l54-54L1734,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1854,174l-54,54l-54-54l54-54L1854,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#444444" d="M1974,174l-54,54l-54-54l54-54L1974,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 120;0 120;0 120;0 -120;0 -120;0 120;0 120;0 120"
    keyTimes="0;0.166;0.25;0.333;0.583;0.666;0.833;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>


  <path fill="#888888" d="M114,114l-54,54L6,114l54-54L114,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M234,114l-54,54l-54-54l54-54L234,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M354,114l-54,54l-54-54l54-54L354,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M474,114l-54,54l-54-54l54-54L474,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M594,114l-54,54l-54-54l54-54L594,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M714,114l-54,54l-54-54l54-54L714,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M834,114l-54,54l-54-54l54-54L834,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M954,114l-54,54l-54-54l54-54L954,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1074,114l-54,54l-54-54l54-54L1074,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1194,114l-54,54l-54-54l54-54L1194,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1314,114l-54,54l-54-54l54-54L1314,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1434,114l-54,54l-54-54l54-54L1434,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1554,114l-54,54l-54-54l54-54L1554,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1674,114l-54,54l-54-54l54-54L1674,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1794,114l-54,54l-54-54l54-54L1794,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#888888" d="M1914,114l-54,54l-54-54l54-54L1914,114z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 240;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.125;0.208;0.5;0.708;0.791;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>

  <path fill="#bbbbbb" d="M54,174L0,228l-54-54l54-54L54,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M174,174l-54,54l-54-54l54-54L174,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M294,174l-54,54l-54-54l54-54L294,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M414,174l-54,54l-54-54l54-54L414,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M534,174l-54,54l-54-54l54-54L534,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M654,174l-54,54l-54-54l54-54L654,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M774,174l-54,54l-54-54l54-54L774,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M894,174l-54,54l-54-54l54-54L894,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1014,174l-54,54l-54-54l54-54L1014,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1134,174l-54,54l-54-54l54-54L1134,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.125 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1254,174l-54,54l-54-54l54-54L1254,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.25 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1374,174l-54,54l-54-54l54-54L1374,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.375 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1494,174l-54,54l-54-54l54-54L1494,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.5 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1614,174l-54,54l-54-54l54-54L1614,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.625 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1734,174l-54,54l-54-54l54-54L1734,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.75 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1854,174l-54,54l-54-54l54-54L1854,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.875 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>
  <path fill="#bbbbbb" d="M1974,174l-54,54l-54-54l54-54L1974,174z">
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 240;0 0;0 0;0 0;0 0;0 0;0 240;0 240"
    keyTimes="0;0.083;0.333;0.5;0.666;0.833;0.916;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1 * animationSpeed}s"
    dur="${9 * animationSpeed}s" repeatCount="indefinite"/>
  </path>

  <path d="M1020,180l60,60H960h0L1020,180z M840,240l-60-60l-60,60l-60-60l-60,60h120h0L840,240L840,240l120,0l-60-60L840,240z
     M1200,240h120l-60-60L1200,240z M1080,240h120l-60-60L1080,240z M1320,240h120l-60-60L1320,240z M1560,240h120l-60-60L1560,240z
     M1440,240h120l-60-60L1440,240z M1860,180l-60,60h120L1860,180z M1680,240h120l-60-60L1680,240z M240,240h120h0l-60-60L240,240z
     M120,240L120,240h120l-60-60L120,240z M0,240h120l-60-60L0,240z M480,240h120h0l-60-60L480,240z M360,240h120l-60-60L360,240z"/>







  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}